module.exports = __webpack_public_path__ + "img/en_legalStatementBack.8d9045ef.jpg";